<template>
  <div>
    <div class="mb-7 pa-3">
      <StudentFilter @onFilter="handleFilter" />
    </div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :options.sync="pagination"
        :items-per-page="10"
        :server-items-length="totalItems"
        :headers="headers"
        :footer-props="footerTable"
        :items="listReports"
        sort-by="name"
        v-bind="this.$attrs"
        loading-text="Đang Tải"
        :loading="loading"
        :hide-default-footer="!listReports[0]"
      >
        <template v-slot:no-data>
          <div class="text-center">Không tìm thấy dữ liệu</div>
        </template>
        <template v-slot:[`item.stt`]="{ index }">
          {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <CardStudentName :student="item.student" link />
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          <span v-if="item.student && item.student.dob">{{ item.student.dob | ddmmyyyy }}</span>
        </template>
        <template v-slot:[`item.currentClass`]="{ item }">
          <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
            <span v-if="item.class">{{ item.class.title || '' }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.totalAmount`]="{ item }">
          {{ item.totalAmount | price }}
        </template>
        <template v-slot:[`item.doneAt`]="{ item }">
          {{ item.doneAt | ddmmyyyyhhmm }}
        </template>
      </v-data-table>
      <div class="mb-7">
        <TotalPaid />
      </div>
    </v-card>
  </div>
</template>

<script>
import StatusAction from '@/modules/tuitionFee/detail-period/StatusAction.vue'
import StudentFilter from './StudentFilter.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { originHeaders } from './helper'
import ActionReport from '@/modules/tuitionFee/detail-period/action/ActionReport.vue'
import TotalPayment from '@/modules/tuitionFee/detail-period/TotalPayment.vue'
import ActionDetail from '@/modules/tuitionFee/detail-period/action/ActionDetail.vue'
import AmountPaid from '@/modules/tuitionFee/detail-period/action/AmountPaid.vue'
import AmountDebt from '@/modules/tuitionFee/detail-period/action/AmountDebt.vue'
import TotalPaid from './TotalPaid.vue'
export default {
  components: {
    StatusAction,
    ActionDetail,
    StudentFilter,
    CardStudentName,
    TotalPayment,
    ActionReport,
    AmountPaid,
    AmountDebt,
    TotalPaid
  },
  data() {
    return {
      pagination: {},
      pageText: '',
      loading: false
    }
  },
  computed: {
    headers() {
      return originHeaders()
    },
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      totalItems: 'tuitionFeeReport/totalItems',
      ownClassIds: 'auth/ownClassIds',
      user: 'auth/user',
      reports: 'tuitionFeeReport/reports',
      customQuery: 'tuitionFeeReport/customQuery'
    }),
    listReports() {
      if (this.detailPeriod.status === 'finished') return this.reports
      else return []
    },
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  async created() {
    this.setState({ attribute: 'totalFeePaid', value: null })
  },
  async mounted() {
    await this.handleFilter({})
  },
  methods: {
    ...mapActions({
      fetchReports: 'tuitionFeeReport/fetchReports',
      setReport: 'tuitionFeeReport/setReport',
      getTotalFeePaid: 'tuitionFeePeriod/getTotalFeePaid'
    }),
    ...mapMutations({
      setCustomQuery: 'tuitionFeeReport/setCustomQuery',
      setState: 'tuitionFeePeriod/setState'
    }),

    async handleFilter(filter) {
      this.pagination.page = 1
      await this.getReportByPagination(1, this.pagination.itemsPerPage)
      let params = {
        isPaid: true,
        doneAt_gte: this.$route.params.start,
        doneAt_lte: this.$route.params.end,
        period: this.detailPeriod.id,
        grade: filter.grade ? filter.grade : null,
        class: filter.class ? filter.class : this.user.role.type === 'teacher' ? this.ownClassIds : null
      }
      if (filter.student) {
        this.setReport(this.reports[0])
        params = { ...params, student: filter.student }
      }
      await this.setCustomQuery(params)
      await this.getReportByPagination(1, this.pagination.itemsPerPage)
      await this.setTotalFee(params)
    },
    async setTotalFee(params) {
      if (this.detailPeriod.id && this.detailPeriod.status === 'finished') {
        await this.getTotalFeePaid(params)
      } else if (this.detailPeriod.status === 'created') {
        this.setState({ attribute: 'totalFeePaid', value: null })
      }
    },
    setPageText(page, itemsPerPage) {
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > this.totalItems || pageStop === -1 ? this.totalItems : pageStop
      this.pageText = `${pageStart}-${pageStop} trên ${this.totalItems}`
    },
    async getReportByPagination(page, itemsPerPage) {
      const params = {
        ...this.customQuery,
        class_in: this.user.role.type === 'teacher' ? this.ownClassIds : null
      }
      this.loading = true
      await this.fetchReports({
        ...params,
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: 'nameToNumber:ASC'
      })
      this.loading = false
      await this.setPageText(page, itemsPerPage)
    }
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.getReportByPagination(newOptions.page, newOptions.itemsPerPage)
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}

.tooltip {
  word-wrap: break-word;
}

div.note {
  max-width: 400px;
}

@media screen and (max-width: 1597px) {
  div.note {
    max-width: 300px;
  }
}

@media screen and (max-width: 1497px) {
  div.note {
    max-width: 200px;
  }
}
</style>
